import { IScene } from '@/types'

/**
 * Director's route-matching algorithm (exact match first, then subpath match
 * where the next character is '/' or end-of-string, longest route wins),
 * extracted so non-render code can ask "which scene owns this pathname" with
 * identical semantics. Deliberately does NOT apply Director's `defaultSceneId`
 * fallback — that id is a per-page prop the callers here don't have, and a
 * scene-scoped feature gate must never inherit from an unrelated default
 * scene.
 */
export function matchSceneByPathname(
  scenes: Record<string, IScene> | undefined,
  pathname: string
): IScene | undefined {
  if (!pathname || !scenes) return undefined

  const allScenes = Object.values(scenes)
  const exactMatch = allScenes.find((scene) => scene.route === pathname)
  if (exactMatch) return exactMatch

  return allScenes
    .filter((scene) => {
      const sceneRoute = scene.route
      if (!sceneRoute) return false

      // Ensure pathname starts with sceneRoute AND the next character is '/'
      // or end of string — prevents /checkout matching /checkout-old.
      return pathname.startsWith(sceneRoute) &&
        (pathname.length === sceneRoute.length || pathname[sceneRoute.length] === '/')
    })
    .sort((a, b) => (b.route?.length || 0) - (a.route?.length || 0))[0]
}
